import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { Switch } from 'antd';
import Select from 'react-select';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import  { exportedVisibleTabs } from '../../../devTab/devRole/crud/pagesPermission';

const PagesPermission = (props ) => {

  const { api, userData, menuPages, menuTabs } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;

  const { showModal, toggleModal, refreshTable, tittle, idRow  } = props;

  const { wareHouseData } = useContext(DataContext);


  const [settings, setSettings] = useState({});
  const [loadingEffect, setLoadingEffect] = useState(false);

  useEffect(() => {
    console.log('exportedVisibleTabs:', exportedVisibleTabs);
  }, []);


  useEffect(() => {
  
    if (idRow) {
      setSettings(
        {
          productPage: idRow.productPage,
          categoryPage: idRow.categoryPage,
          stockControlPage: idRow.stockControlPage,

          customerPage: idRow.customerPage,
          supplierPage: idRow.supplierPage,
          expensePage: idRow.expensePage,
          wareHousePage: idRow.wareHousePage,
          deliveryPage: idRow.deliveryPage,

    
          customerAccountPage: idRow.customerAccountPage,
          supplierAccountPage: idRow.supplierAccountPage,
          expenseAccountPage: idRow.expenseAccountPage,
          deliveryAccountPage: idRow.deliveryAccountPage,
          expenseInvoicePage: idRow.expenseInvoicePage,
          salesInvoicePage: idRow.salesInvoicePage,
          purchaseInvoicePage: idRow.purchaseInvoicePage,

          stockActivityPage: idRow.stockActivityPage,
          stockValuePage: idRow.stockValuePage,
          warrantyPage: idRow.warrantyPage,

          //report tab
          productSalesPage: idRow.productSalesPage,
          allTransactionsPage: idRow.allTransactionsPage,
          incomeStatementPage: idRow.incomeStatementPage,
          cashFlowPage: idRow.cashFlowPage,

          generalPage: idRow.generalPage,
          userPage: idRow.userPage,
          rolePage: idRow.rolePage,
          saleSettingPage: idRow.saleSettingPage,
          piSettingPage: idRow.piSettingPage,
          productSettingPage: idRow.productSettingPage,
          lisencePage: idRow.lisencePage,

          lowInStockPage: idRow.lowInStockPage,

          costChangePage: idRow.costChangePage,

          //vsibility
          productPageVisibility: idRow.productPageVisibility,
          categoryPageVisibility: idRow.categoryPageVisibility,
          stockControlPageVisibility: idRow.stockControlPageVisibility,

          customerPageVisibility: idRow.customerPageVisibility,
          supplierPageVisibility: idRow.supplierPageVisibility,
          expensePageVisibility: idRow.expensePageVisibility,
          wareHousePageVisibility: idRow.wareHousePageVisibility,
          deliveryPageVisibility: idRow.deliveryPageVisibility,

    
          customerAccountPageVisibility: idRow.customerAccountPageVisibility,
          supplierAccountPageVisibility: idRow.supplierAccountPageVisibility,
          expenseAccountPageVisibility: idRow.expenseAccountPageVisibility,
          deliveryAccountPageVisibility: idRow.deliveryAccountPageVisibility,
          expenseInvoicePageVisibility: idRow.expenseInvoicePageVisibility,
          salesInvoicePageVisibility: idRow.salesInvoicePageVisibility,
          purchaseInvoicePageVisibility: idRow.purchaseInvoicePageVisibility,

          stockActivityPageVisibility: idRow.stockActivityPageVisibility,
          stockValuePageVisibility: idRow.stockValuePageVisibility,
          warrantyPageVisibility: idRow.warrantyPageVisibility,

          //report tab
          productSalesPageVisibility: idRow.productSalesPageVisibility,
          allTransactionsPageVisibility: idRow.allTransactionsPageVisibility,
          incomeStatementPageVisibility: idRow.incomeStatementPageVisibility,
          cashFlowPageVisibility: idRow.cashFlowPageVisibility,

          generalPageVisibility: idRow.generalPageVisibility,
          userPageVisibility: idRow.userPageVisibility,
          rolePageVisibility: idRow.rolePageVisibility,
          saleSettingPageVisibility: idRow.saleSettingPageVisibility,
          piSettingPageVisibility: idRow.piSettingPageVisibility,
          productSettingPageVisibility: idRow.productSettingPageVisibility,
          lisencePageVisibility: idRow.lisencePageVisibility,





        }
      )

    }
  }, [idRow]);



  const handleSubmit = async () => {
    setLoadingEffect(true);

    const id = idRow.id;

    let res = await api.post(`/role/editPermissions`, JSON.stringify({ id, settings }))
    if (res.data.status) {
      toast.success(res.data.message);
      refreshTable();
      toggleModal();
    }
    else {
      toast.error(res.data.message);
    }

    setLoadingEffect(false);
  }


  const handleChange = (name, value) => {
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  }



  return (
    <Modal show={showModal} backdrop="static" size='xl' onHide={toggleModal} >
      <Modal.Header style={{ background: "#1f2937" }}>
        <Modal.Title style={{ color: "white" }}>{idRow.name} {menuPages.PagesPermissions}</Modal.Title> 
      </Modal.Header>
      <Modal.Body>
        <div style={{ userSelect: 'none', height: 'auto', display: 'flex', flexDirection: 'row', marginBottom: '10%' }}>
        
          {/* Product Tab  */}  
     
        
          <Form style={{ width: '25%' }}>

            <h4 style={{ textAlign: 'left' }}>{menuPages.Product}</h4>
            <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

      
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Products}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('productPage', e)} checked={settings.productPage} />
            </Form.Group>
         
            
         
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Category}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('categoryPage', e)} checked={settings.categoryPage} />
            </Form.Group>
       

         
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.StockControl}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('stockControlPage', e)} checked={settings.stockControlPage} />
            </Form.Group>
          
          </Form>
         

          {/* Account Tab  */}
     
          <Form style={{ width: '25%' }}>

            <h4 style={{ textAlign: 'left' }}>{menuTabs.Accounts}</h4>
            <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

          
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Customer}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('customerPage', e)} checked={settings.customerPage} />
            </Form.Group>
        

      
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Supplier}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('supplierPage', e)} checked={settings.supplierPage} />
            </Form.Group>
         

           
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Expense}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('expensePage', e)} checked={settings.expensePage} />
            </Form.Group>
           
            
          
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.WareHouse}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('wareHousePage', e)} checked={settings.wareHousePage} />
            </Form.Group>
            


            
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Delivery}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('deliveryPage', e)} checked={settings.deliveryPage} />
            </Form.Group>
             


          </Form>


          {/* Transaction Tab  */}
          <Form style={{ width: '25%' }}>

      
            <h4 style={{ textAlign: 'left' }}>{menuTabs.Transactions}</h4>
            <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>
           
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Customer}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('customerAccountPage', e)} checked={settings.customerAccountPage} />
            </Form.Group>
              

       
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Supplier}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('supplierAccountPage', e)} checked={settings.supplierAccountPage} />
            </Form.Group>
             

           
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Expense}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('expenseAccountPage', e)} checked={settings.expenseAccountPage} />
            </Form.Group>
            


           
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Delivery}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('deliveryAccountPage', e)} checked={settings.deliveryAccountPage} />
            </Form.Group>

         

       

            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.ExpenseInvoice}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('expenseInvoicePage', e)} checked={settings.expenseInvoicePage} />
            </Form.Group>
          

     
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.SalesInvoice}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('salesInvoicePage', e)} checked={settings.salesInvoicePage} />
            </Form.Group>
         
            
         
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.PurchaseInvoice}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('purchaseInvoicePage', e)} checked={settings.purchaseInvoicePage} />
            </Form.Group>
   
          </Form>


          {/* Report Tab  */}
          <Form style={{ width: '25%' }}>


            <h4 style={{ textAlign: 'left' }}>{menuTabs.Reports}</h4>
            <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>
       
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.ProductSales}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('productSalesPage', e)} checked={settings.productSalesPage} />
            </Form.Group>
   

           
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.AllTransactions}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('allTransactionsPage', e)} checked={settings.allTransactionsPage} />
            </Form.Group>
     

     
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.CashFlow}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('cashFlowPage', e)} checked={settings.cashFlowPage} />
            </Form.Group>
              


     
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.IncomeStatement}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('incomeStatementPage', e)} checked={settings.incomeStatementPage} />
            </Form.Group>

            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Warranty}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('warrantyPage', e)} checked={settings.warrantyPage} />
            </Form.Group>
      
          </Form>



        </div>

        <div style={{ userSelect: 'none', height: 'auto', display: 'flex', flexDirection: 'row', marginBottom: '10%' }}>

          {/* Stock managment Tab  */}
          <Form style={{ width: '25%' }}>


            <h4 style={{ textAlign: 'left' }}>{menuTabs.StockMgmnt}</h4>
            <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

         
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.StockActivity}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('stockActivityPage', e)} checked={settings.stockActivityPage} />
            </Form.Group>
      

          
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.StockValue}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('stockValuePage', e)} checked={settings.stockValuePage} />
            </Form.Group>

            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>Cost change</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('costChangePage', e)} checked={settings.costChangePage} />
            </Form.Group>
      

       
      

            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>LowInStock</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('lowInStockPage', e)} checked={settings.lowInStockPage} />
            </Form.Group>
       
          </Form>

          {/* Settings Tab  */}
          <Form style={{ width: '25%' }}>


            <h4 style={{ textAlign: 'left' }}>{menuTabs.Settings}</h4>
            <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

        
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.General}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('generalPage', e)} checked={settings.generalPage} />
            </Form.Group>
        

            
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Users}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('userPage', e)} checked={settings.userPage} />
            </Form.Group>
          

          
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Role}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('rolePage', e)} checked={settings.rolePage} />
            </Form.Group>
          


      
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.SaleSettings}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('saleSettingPage', e)} checked={settings.saleSettingPage} />
            </Form.Group>
                   

  
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.PiSettings}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('piSettingPage', e)} checked={settings.piSettingPage} />
            </Form.Group>

         

       
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.ProductSettings}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('productSettingPage', e)} checked={settings.productSettingPage} />
            </Form.Group>
                

        
            <Form.Group as={Row} className="mb-9">
              <Form.Label column sm={8}>{menuPages.Lisence}</Form.Label>
              <Switch defaultChecked onChange={(e) => handleChange('lisencePage', e)} checked={settings.lisencePage} />
            </Form.Group>
      
          </Form>




        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={toggleModal}>
            {menuPages.Close}
          </button>

          <button type="button" className="btn btn-primary" onClick={handleSubmit}>
            {menuPages.SaveData}
          </button>

          {loadingEffect && (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          )}  
        </div>
      </Modal.Body>
    </Modal>
  )
}


export default PagesPermission;